/**
 * OAuth Storage Utility
 * Framework-agnostic local storage for OAuth state
 */

const OAUTH_STATE_KEY = 'oauth_state';
const OAUTH_REDIRECT_KEY = 'oauth_redirect_after_login';

export class OAuthStorage {
  /**
   * Store OAuth state parameter for CSRF protection
   */
  static setState(state: string): void {
    try {
      localStorage.setItem(OAUTH_STATE_KEY, state);
    } catch (error) {
      console.error('Failed to store OAuth state:', error);
    }
  }

  /**
   * Retrieve and remove OAuth state parameter
   */
  static getAndClearState(): string | null {
    try {
      const state = localStorage.getItem(OAUTH_STATE_KEY);
      if (state) {
        localStorage.removeItem(OAUTH_STATE_KEY);
      }
      return state;
    } catch (error) {
      console.error('Failed to retrieve OAuth state:', error);
      return null;
    }
  }

  /**
   * Store redirect URL to return to after OAuth completes
   */
  static setRedirectUrl(url: string): void {
    try {
      localStorage.setItem(OAUTH_REDIRECT_KEY, url);
    } catch (error) {
      console.error('Failed to store redirect URL:', error);
    }
  }

  /**
   * Retrieve and remove redirect URL
   */
  static getAndClearRedirectUrl(): string | null {
    try {
      const url = localStorage.getItem(OAUTH_REDIRECT_KEY);
      if (url) {
        localStorage.removeItem(OAUTH_REDIRECT_KEY);
      }
      return url;
    } catch (error) {
      console.error('Failed to retrieve redirect URL:', error);
      return null;
    }
  }

  /**
   * Clear all OAuth storage
   */
  static clear(): void {
    try {
      localStorage.removeItem(OAUTH_STATE_KEY);
      localStorage.removeItem(OAUTH_REDIRECT_KEY);
    } catch (error) {
      console.error('Failed to clear OAuth storage:', error);
    }
  }
}
